import PATHS from 'routes/paths';
import { NOVA_URL } from 'utils/constants';
import {
  API_KEYS_VIEW_ALL,
  CLIENTS_VIEW_ALL,
  COMPANIES_VIEW_ALL,
  WEBHOOK_CLIENTS_VIEW_ALL,
  LINKS_VIEW_ALL,
  BILLABLE_SMS_NOTIFICATIONS_VIEW_ALL,
  CABOODLE_OUTLETS_VIEW_ALL,
  CABOODLE_PAYOUT_LOGS_VIEW_ALL,
  CABOODLE_PAYOUTS_VIEW_ALL,
  TRANSACTIONS_VIEW_ALL,
  PAYOUTS_VIEW_ALL,
  REFUNDS_VIEW_ALL,
  BILLABLE_SMS_NOTIFICATIONS_PAYMENTS_VIEW_ALL,
  TRANSFERS_VIEW_ALL,
  CHARGEBACKS_VIEW_ALL,
  FRAUD_NOTIFICATIONS_VIEW_ALL,
} from 'utils/permissions';

export const PRODUCTS = {
  name: 'Products',
  to: PATHS.products,
};
export const FUNDRAISERS = {
  name: 'Fundraisers',
  to: PATHS.fundraisers,
};
export const ORDERS = {
  name: 'Donations',
  to: PATHS.orders,
};
export const PROFILE = {
  name: 'Profile',
  to: PATHS.profile,
};

export let NAVIGATION_ITEMS = new Set();

export const navigationItemsByConfig = (brand) => {
  if (brand.hasFundraisers) {
    NAVIGATION_ITEMS = NAVIGATION_ITEMS.add(FUNDRAISERS).add(ORDERS);
  }
  if (brand.hasProducts) {
    NAVIGATION_ITEMS = NAVIGATION_ITEMS.add(PRODUCTS);
  }
  return Array.from(NAVIGATION_ITEMS);
};

/*
export const COMPANY_INFO = {
  name: 'Company Info',
  to: PATHS.companyInfo,
};
export const BRANDING = {
  name: 'Branding',
  to: PATHS.branding,
};
export const AUTOMATION = {
  name: 'Automation',
  to: PATHS.automation,
};
export const SHIPPING = {
  name: 'Shipping',
  to: PATHS.shipping,
};

export const SETTING_ITEMS = [COMPANY_INFO, BRANDING, AUTOMATION, SHIPPING];
*/

export const PAYMENT_LINKS = [
  {
    value: TRANSACTIONS_VIEW_ALL,
    url: `${NOVA_URL}/resources/transactions`,
    to: PATHS.transactions,
    name: 'Transactions',
  },
  {
    value: REFUNDS_VIEW_ALL,
    url: `${NOVA_URL}/resources/refunds`,
    to: PATHS.refunds,
    name: 'Refunds',
  },
  {
    value: PAYOUTS_VIEW_ALL,
    url: `${NOVA_URL}/resources/payouts`,
    to: PATHS.payouts,
    name: 'Payouts',
  },
  {
    value: BILLABLE_SMS_NOTIFICATIONS_PAYMENTS_VIEW_ALL,
    url: `${NOVA_URL}/resources/billable-sms-notifications-payments`,
    name: 'SMS Payments',
  },
  {
    value: TRANSFERS_VIEW_ALL,
    url: `${NOVA_URL}/resources/transfers`,
    to: PATHS.transfers,
    name: 'Transfers',
  },
];
export const DISPUTE_LINKS = [
  {
    value: CHARGEBACKS_VIEW_ALL,
    url: `${NOVA_URL}/resources/chargebacks`,
    to: PATHS.disputes,
    name: 'Disputes',
  },
  {
    value: FRAUD_NOTIFICATIONS_VIEW_ALL,
    url: `${NOVA_URL}/resources/fraud-notifications`,
    name: 'Reviews',
  },
];
export const BILLING_LINKS = [
  {
    value: LINKS_VIEW_ALL,
    url: `${NOVA_URL}/resources/links`,
    name: 'Invoices',
  },
  {
    value: BILLABLE_SMS_NOTIFICATIONS_VIEW_ALL,
    url: `${NOVA_URL}/resources/billable-sms-notifications`,
    name: 'Billable SMS',
  },
];
export const CABOODLE_LINKS = [
  {
    value: CABOODLE_OUTLETS_VIEW_ALL,
    url: `${NOVA_URL}/resources/caboodle-outlets`,
    name: 'Outlets',
  },
  {
    value: CABOODLE_PAYOUTS_VIEW_ALL,
    url: `${NOVA_URL}/resources/caboodle-payouts`,
    name: 'Caboodle Payouts',
  },
  {
    url: `${NOVA_URL}/resources/caboodle-payout-logs`,
    name: 'Caboodle Payout Logs',
    value: CABOODLE_PAYOUT_LOGS_VIEW_ALL,
  },
];
export const ADMIN_LINKS = [
  {
    url: `${NOVA_URL}/resources/api-keys`,
    name: 'API Keys',
    value: API_KEYS_VIEW_ALL,
  },
  {
    url: `${NOVA_URL}/resources/clients`,
    to: PATHS.clients,
    name: 'Clients',
    value: CLIENTS_VIEW_ALL,
  },
  {
    value: COMPANIES_VIEW_ALL,
    url: `${NOVA_URL}/resources/companies`,
    name: 'Companies',
    to: PATHS.companies,
  },
  {
    url: `${NOVA_URL}/resources/fee-structures`,
    name: 'Fee Structures',
    visibleToSuperAdmin: true,
  },
  {
    url: `${NOVA_URL}/resources/integrations`,
    to: PATHS.integrations,
    name: 'Integrations',
    visibleToSuperAdmin: true,
  },
  {
    url: `${NOVA_URL}/resources/permissions`,
    name: 'Permissions',
    visibleToSuperAdmin: true,
  },
  {
    url: `${NOVA_URL}/resources/roles`,
    name: 'Roles',
    visibleToSuperAdmin: true,
  },
  {
    url: `${NOVA_URL}/resources/sms-prices`,
    name: 'Sms Prices',
    visibleToSuperAdmin: true,
  },
  {
    url: `${NOVA_URL}/resources/stores`,
    name: 'Stores',
    visibleToSuperAdmin: true,
  },
  {
    url: `${NOVA_URL}/resources/users`,
    name: 'Users',
    visibleToSuperAdmin: true,
  },
  {
    value: WEBHOOK_CLIENTS_VIEW_ALL,
    url: `${NOVA_URL}/resources/webhook-clients`,
    name: 'Webhook Clients',
  },
  {
    url: `${NOVA_URL}/resources/webhook-requests`,
    to: PATHS.webhooks,
    name: 'Webhook Requests',
    visibleToSuperAdmin: true,
  },
];
